import { AskNovoAiQuestionResponse, RecentQuestionsResponse } from 'redux/actions/help-options';
import { HelpOptions } from 'redux/schemas/models/help-options';

export enum AskNovoAiDrawerState {
  INITIAL = 'initial',
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
}

export type AskNovoAiState = {
  isOpen: boolean;
  drawerState: AskNovoAiDrawerState;
  question: string;
  response?: AskNovoAiQuestionResponse;
  recentQuestions: RecentQuestionsResponse[];
  helpOptions?: HelpOptions;
  // Vote state for helpfulness rating
  voteState: {
    [questionId: number]: {
      upvoted: boolean;
      downvoted: boolean;
      isLoading: boolean;
      showFeedback: boolean;
    };
  };
};

const URLS_TO_HIDE_ASK_NOVO_AI = [
  '/analytics',
  '/user-management',
  '/custom_downloads',
  '/learner-progress',
  '/course_communications',
  '/team-facilitation',
  '/edit_basics',
  '/home/edit',
  '/mentees/User',
];

export default URLS_TO_HIDE_ASK_NOVO_AI;
